<template>
  <div class="main-home">
    <div class="main">
      <div class="main-left">
        <div class="user-wrap">
          <img class="user-avatar" @click="goto('home', curIndex)" :src="logoSrc" alt="">
          <div class="user-name">{{ userInfo.userName }}</div>
          <div class="phone">{{ userInfo.loginName }}</div>
        </div>
        <div class="list">
                  <div 
          v-for="(menu, index) in menuList" 
          :class="['list-item', curIndex === index && 'active']" 
          :key="index" 
          @click="goto(menu.pathName, index)"
          >{{ menu.title }}</div>
        </div>
      </div>
      <div class="main-right">
        <keep-alive>
          <router-view v-if="$route.meta.keepAlive" :key="$route.fullPath" />
        </keep-alive>
        <router-view v-if="!$route.meta.keepAlive" :key="$route.fullPath" />
      </div>
    </div>
  </div>
</template>

<script>
import {mapGetters, mapState} from 'vuex'
export default {
  name: 'Main',
  data() {
    return {
      curIndex: null
    }
  },
  watch: {
    $route(to, from) {
      const name = to.name
      this.filterCurIndex(name)
    }
  },
  created() {
    const { name } = this.$route
    this.filterCurIndex(name)
  },
  
  mounted() {
    // 非医端隐藏 我的订单&我的就诊
    // if (this.isNonMedical) {
    //   this.menuList = [
    //     // { title: '我的患者', pathName: 'patient' },
    //     { title: '个人中心', pathName: 'userCenter' }
    //   ]
    //   // 重新设置当前索引
    //   this.filterCurIndex(this.$route.name)
    // }
  },
  computed: {
      ...mapState({
        userInfo: state => state.user.userInfo,
        isLogin: state => state.user.isLogin,
        isNonMedical: (state) => state.user.isNonMedical,
        authoritys: (state) => state.user.authoritys // 用户权限
      }),
    ...mapGetters(["pageInfo"]),
    
    // 动态菜单列表，根据权限过滤
    menuList() {
      const allMenus = [
        { title: '我的患者', pathName: 'patient' },
        { title: '我的订单', pathName: 'orderList' },
        { title: '我的就诊', pathName: 'diagnoseList' },
        { title: '体质健康检测', pathName: 'physicalFitnessTest' },
        { title: '我的处方', pathName: 'prescription' },
        { title: '个人中心', pathName: 'userCenter' }
      ];
      
      // 根据权限过滤菜单
      return allMenus.filter(menu => {
        // 体质健康检测菜单需要检查权限
        if (menu.pathName === 'physicalFitnessTest') {
          // 检查 authoritys 中的 physicalIdentifyMenuStatus
          // 0显示，1不显示（注意：接口返回的是字符串）
          return this.authoritys?.physicalIdentifyMenuStatus !== "1";
        }
        
        // 其他菜单项正常显示
        return true;
      });
    },
    logoSrc() {
      if (this.pageInfo?.homeLogoUrlState === 1 && !this.pageInfo?.homeLogoUrl) {
        return require('@/assets/images/user_nav_icon.png')
      }
      return this.pageInfo?.homeLogoUrl
    }
    },
    methods: {
      goto(name, index) {
        // 检查路由名称是否有效
        if (!name) {
          console.error('路由名称为空')
          return
        }
        
        window.aplus_queue.push({
          action: "aplus.record",
          arguments: [
            "_sjy.unitManagement.clk",
            "CLK",
            {
              param1: this.$route.name,
            },
          ],
        });
        
        this.curIndex = index
        
        // 使用 try-catch 来捕获可能的错误
        try {
          this.$router.push({ name })
        } catch (error) {
          console.error('路由跳转失败:', error)
        }
      },
      filterCurIndex(name) {
        this.curIndex = this.menuList.findIndex(menu => menu.pathName == name)
        this.curIndex = name == 'diagnoseHistory' ? 2 : this.curIndex
        this.curIndex = name == 'report' ? 2 : this.curIndex
      }
    }
  }
</script>

<style lang="less" scoped>
.main-home {
  width: 100%;
  height: 100%;
  min-height: calc(100vh - 70px);
  padding-top: 62px;
  flex: 1;
  overflow: auto;
  background-color: #f5f5f5;

  .main {
    display: flex;
    width: 1200px;
    margin: 24px auto 20px;
  }

  .main-left {
    width: 320px;
    min-height: 465px;
    background-color: #fff;
    border-radius: 8px;
    margin-right: 16px;
    flex-shrink: 0;
  }

  .main-right {
    width: 864px;
  }
}

.user-wrap {
  width: 100%;
  height: 170px;
  padding-top: 24px;
  box-sizing: border-box;
  border-bottom: 1px solid #EBEDF0;

  .user-avatar {
    width: 64px;
    height: 64px;
    display: block;
    margin: 0 auto;
    cursor: pointer;
  }

  .user-name {
    font-size: 16px;
    line-height: 24px;
    font-weight: 600;
    color: #47515C;
    text-align: center;
    margin-top: 8px;
  }

  .phone {
    font-size: 16px;
    line-height: 24px;
    font-weight: 600;
    margin-top: 4px;
    color: #47515C;
    text-align: center;
  }
}

.list {
  width: 100%;
  padding: 24px 60px 0;
  box-sizing: border-box;

  .list-item {
    width: 100%;
    height: 40px;
    line-height: 38px;
    color: #19B2AD;
    border: 1px solid #19B2AD;
    font-size: 14px;
    text-align: center;
    margin-bottom: 24px;
    background-color: #fff;
    box-sizing: border-box;
    border-radius: 2px;
    cursor: pointer;

    &.active {
      background-color: #19B2AD;
      color: #fff;
    }
  }
}
</style>
